<template>
  <div class="account-view payment-details-form">
    <div class="account-view__content">
      <div class="account-view__section my-5">
        <div class="container is-max-desktop">
          <div class="columns is-multiline">
            <div class="column is-full">
              <h1 class="title is-3 has-text-grey">{{ $t('checkout.paymentDetails.address') }}</h1>
            </div>
            <div class="column is-one-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.firstName') }}
                  *</label>
                <div class="control">
                  <input v-model="value.billingAddress.firstname" class="input" type="text" maxlength="20"
                         name="given-name"
                         autocomplete="given-name"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.firstName')">
                </div>
              </div>
            </div>
            <div class="column is-one-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.lastName') }}
                  *</label>
                <div class="control">
                  <input v-model="value.billingAddress.lastname" class="input" type="text" maxlength="20"
                         name="family-name"
                         autocomplete="family-name"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.lastName')">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container is-max-desktop">
          <div class="columns is-multiline">
            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.street') }}
                  *</label>
                <div class="control">
                  <input v-model="value.billingAddress.street" class="input" type="text" name="street-address"
                         autocomplete="street-address"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.street')">
                </div>
              </div>
            </div>

            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.postalCode') }}
                  *</label>
                <div class="control">
                  <input class="input" v-model="value.billingAddress.postalCode" type="text" name="postal-code"
                         v-if="shippingCountryById(value.billingAddress.countryId)"
                         autocomplete="postal-code"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.postalCode')"
                         :title="'Gültige Postleitzahl aus ' + shippingCountryById(value.billingAddress.countryId).country"
                         :pattern="shippingCountryById(value.billingAddress.countryId).postalCodeRegex">
                </div>
              </div>
            </div>

            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.city') }}
                  *</label>
                <div class="control">
                  <input v-model="value.billingAddress.city" class="input" type="text" name="address-level2"
                         autocomplete="address-level2"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.city')">
                </div>
              </div>
            </div>
            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">Land *</label>
                <div class="control">
                  <select class="input" v-model="value.billingAddress.countryId" autocomplete="off">
                    <option v-for="value in getMaagtechnicShippingCountries" :value="value._id" :key="value._id">
                      {{ value.country }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{
                    $t('checkout.paymentDetails.inputLabels.company')
                  }}</label>
                <div class="control">
                  <input v-model="value.billingAddress.company" class="input" type="text" name="organization"
                         autocomplete="organization"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.company')">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="account-view__section ">
      <div class="container is-max-desktop my-5">
        <div class="columns">
          <div class="column is-full">
            <h2 class="title is-3 has-text-grey">{{ $t('checkout.paymentDetails.shippingAddress') }}</h2>
          </div>
        </div>
        <div class="column is-full">
          <div class="field has-checkbox">
            <label class="checkbox">
              <input class="control" type="checkbox" autocomplete="off"
                     v-model="value.shippingAddressDiffersFromBillingAddress">
              {{ $t('checkout.paymentDetails.inputLabels.shippingAddressDiffersFromBillingAddress') }}
            </label>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="container is-max-desktop" v-if="!isBillingAndShippingEqual">
          <div class="columns is-multiline">
            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.firstName') }}
                  *</label>
                <div class="control">
                  <input v-model="value.shippingAddress.firstname" class="input" type="text" name="given-name"
                         maxlength="20"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.firstName')">
                </div>
              </div>
            </div>
            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.lastName') }}
                  *</label>
                <div class="control">
                  <input v-model="value.shippingAddress.lastname" class="input" type="text" name="family-name"
                         maxlength="20"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.lastName') ">
                </div>
              </div>
            </div>
            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{
                    $t('checkout.paymentDetails.inputLabels.company')
                  }}</label>
                <div class="control">
                  <input v-model="value.shippingAddress.company" class="input" type="text" name="organization"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.company')">
                </div>
              </div>
            </div>

            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.street') }}
                  *</label>
                <div class="control">
                  <input v-model="value.shippingAddress.street" class="input" type="text" name="street-address"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.street') ">
                </div>
              </div>
            </div>

            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.postalCode') }}
                  *</label>
                <div class="control">
                  <input class="input" v-model="value.shippingAddress.postalCode" type="text" name="postal-code"
                         v-if="shippingCountryById(value.shippingAddress.countryId)"
                         :title="'Gültige Postleitzahl aus ' + shippingCountryById(value.shippingAddress.countryId).country"
                         :pattern="shippingCountryById(value.shippingAddress.countryId).postalCodeRegex">
                </div>
              </div>
            </div>

            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">{{ $t('checkout.paymentDetails.inputLabels.city') }}
                  *</label>
                <div class="control">
                  <input v-model="value.shippingAddress.city" class="input" type="text" name="address-level2"
                         :placeholder="$t('checkout.paymentDetails.inputLabels.city') ">
                </div>
              </div>
            </div>

            <div class="column is-half-tablet">
              <div class="field">
                <label class="label is-uppercase mt-3 ml-3">Land *</label>
                <div class="control">
                  <select class="input" v-model="value.shippingAddress.countryId" autocomplete="off">
                    <option v-for="value in getMaagtechnicShippingCountries" :value="value._id">
                      {{ value.country }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import TextField from "../cms-content-types/TextField";
import {mapGetters} from "vuex";
import SvgIcon from "../svg/SvgIcon";

export default {
  name: "AddressForm",
  components: {SvgIcon, TextField},
  props: {
    value: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(['isUserLoggedIn', 'availableShippingCountries', 'userAccountDetails', 'shippingCountryById']),
    isBillingAndShippingEqual(){
      return !this.value.shippingAddressDiffersFromBillingAddress
    },
    // TODO: This is a quick fix solution
    // Maagtechnic will only ship to CH, but the shipping countries have no whitelabel scope atm!
    // But our api returns all available shipping countries, regardless of the specific whitelabel
    // Shipping countries need to be scoped to the whitelabels!!
    getMaagtechnicShippingCountries() {
      return this.availableShippingCountries.filter(shippingCountry => shippingCountry.countryCode === 'CH');
    }
  },
  methods: {
    fetchCMSData() {
      this.$store.dispatch('fetchCMSPage', {urlSlug: "/"});
    },
  },
  async created() {
    this.fetchCMSData();

    let storedPaymentDetails = this.$store.getters.paymentDetails;
    if (Object.keys(storedPaymentDetails).length > 0) {
      this.$emit('input', {
        billingAddress: {...this.value.billingAddress, ...storedPaymentDetails.billingAddress},
        shippingAddress: {...this.value.shippingAddress, ...storedPaymentDetails.shippingAddress},
        shippingAddressDiffersFromBillingAddress: !storedPaymentDetails.isBillingAndShippingEqual,
      })
    }
  },
}
</script>

<style lang="scss">
.payment-details-form {
  padding-top: $header-height-mobile;
  @media screen and (min-width: $desktop) {
    padding-top: 0;
  }
}

</style>
